export default __webpack_public_path__ + "sounds/framework/friendNotify_R.79ffed7e.mp3?79ffed7e";